import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

import { idField } from 'utils/builder/fields';

const imageCardFields = [
  idField,
  imageField('image'),
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Card title',
    helperText: 'Main title displayed below the image (e.g. Create, Empower, Unleash).',
  },
  {
    name: 'subhead',
    type: 'string',
    helperText: 'Optional short subheading shown right under the title.',
  },
  {
    name: 'description',
    type: 'richText',
    defaultValue: '<p>Card description text.</p>',
    helperText: 'Supporting copy for the card. Supports rich text.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type ImageCardConfigProps = GenerateBuilder<typeof imageCardFields>;

export default imageCardFields;
